<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array, Object],
        multiple: Boolean,
        returnObject: Boolean,
        notClearable: Boolean,
        selectMax: Boolean,
        label: String,
        readonly: Boolean,
        rules: Array,
        type: String,
        cycle: String,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const skill = ref(null);
        const skills = ref([]);

        function findAll() {
            loading.value = true;
            axios.get('/evaluationSkills', {
                params: {
                    sortBy: "postDateTime",
                    descending: true,
                    allRecords: true,
                }
            }).then(response => {
                skills.value = response.data.elements;
                if(skills.value.length > 0 && props.selectMax)
                    emit('input', skills.value[0].id);
            }).finally(() => {
                loading.value = false;
            })
        }

        watch(() => props.value, () => {
            skill.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            skill,
            skills,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="skill"
            :label="label"
            :items="skills"
            item-value="id"
            item-text="name"
            outlined
            dense
            :return-object="returnObject"
            :loading="loading"
            :readonly="readonly"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', skill)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>